import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { IhmNotificationsModule } from '../ihm-notifications/ihm-notifications.module';
import { IhmHeaderComponent } from './ihm-header.component';

@NgModule({
  imports: [CommonModule, MatCardModule, MatDividerModule, IhmNotificationsModule],
  declarations: [IhmHeaderComponent],
  exports: [IhmHeaderComponent]
})
export class IhmHeaderModule {}
